import React from 'react';
import { FlatList } from 'react-native';
import type { MarketProps } from '../../types';
import { Checkbox } from '../../Components';
import { Button, Text, View } from '../../Components/Themed';


type MarketSelectorProps = {
    markets:MarketProps[],
    selected_markets:string[],
    onSelectMarket:(m:MarketProps) => void,
    onDeselectMarket:(m:MarketProps) => void
}
const MarketSelector = ({ markets, selected_markets, onSelectMarket, onDeselectMarket }:MarketSelectorProps) => {

    const renderMarkets = (data:{item:MarketProps, index:number}) => {
        const selected = selected_markets.find(se => se == data.item.market_id) ? true : false;
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', padding:4 }} onPress={() => selected ? onDeselectMarket(data.item) : onSelectMarket(data.item)}>
                <Checkbox checked={selected} disabled onSelect={() => console.log('')}/>
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text size={12} weight='bold' theme='h1'>{data.item.type == 'Stat' ? data.item.stat_label : data.item.type}</Text>
                    <Text style={{ marginTop:3 }} theme='light'>{data.item.description}</Text>
                </View>
            </Button>
        )
    }
    return (
        <View style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Select Market</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Manage the markets that are shown on the dashboard</Text>
                </View>
            </View>
            <View transparent style={{ maxHeight:400 }}>
                <FlatList
                    key={'market_selector'}
                    data={markets}
                    renderItem={renderMarkets}
                    keyExtractor={(item) => item.market_id.toString()}
                />
            </View>
        </View>
    )
}

export default MarketSelector